import BronzePass from './assets/bronze_pass_card.png';
import GoldPass from './assets/gold_pass_card.png';
import SilverPass from './assets/silver_pass_card.png';
import {
  TXTCLI_BRONZE_POWER_PASS,
  TXTCLI_GOLD_POWER_PASS,
  TXTCLI_More,
  TXTCLI_NEW_BRONZE_BUNDLE,
  TXTCLI_NEW_GOLD_BUNDLE,
  TXTCLI_NEW_SILVER_BUNDLE,
  TXTCLI_SILVER_POWER_PASS,
  TXTCLI_The_Passes,
  TXTCLI_The_Path,
  TXTINT_Friday,
  TXTINT_Monday,
  TXTINT_Saturday,
  TXTINT_Sunday,
  TXTINT_Thursday,
  TXTINT_Tuesday,
  TXTINT_Wednesday
} from './constants.messages.json';
import type { AwardType, EventType } from './types';
import { Award, Event, NavigationTabs, PassType } from './types';

export const NAVIGATION_DATA = {
  thePath: {
    title: TXTCLI_The_Path,
    shortTitle: TXTCLI_The_Path,
    tabName: NavigationTabs.thePath
  },
  thePasses: {
    title: TXTCLI_The_Passes,
    shortTitle: TXTCLI_The_Passes,
    tabName: NavigationTabs.thePasses
  },
  more: {
    title: TXTCLI_More,
    shortTitle: TXTCLI_More,
    tabName: NavigationTabs.more
  }
};

export const NAVIGATION_TABS = [
  NAVIGATION_DATA.thePath,
  NAVIGATION_DATA.thePasses,
  NAVIGATION_DATA.more
];

export const ENDPOINTS = {
  HTTP: {
    real: '/api/v1-preview/mtt/powerpath',
    mock: '/api/v1-preview/mtt/powerpathmock',
    redeem: '/api/v1-preview/mtl/pass/redeem'
  },
  WS: {
    real: '/api/v1-preview/stream/mtt/powerpath',
    mock: '/api/v1-preview/stream/mtt/powerpathmock'
  }
};

export const PASSES_TITLE_TRANSLATIONS = {
  [PassType.gold]: TXTCLI_GOLD_POWER_PASS,
  [PassType.silver]: TXTCLI_SILVER_POWER_PASS,
  [PassType.bronze]: TXTCLI_BRONZE_POWER_PASS
};
export const COMING_SOON_PASSES_TRANSLATIONS = {
  [PassType.gold]: TXTCLI_NEW_GOLD_BUNDLE,
  [PassType.silver]: TXTCLI_NEW_SILVER_BUNDLE,
  [PassType.bronze]: TXTCLI_NEW_BRONZE_BUNDLE
};

export const MINIMUM_PASS_COUNT = 3;

export const PASS_IMAGES = {
  [PassType.gold]: GoldPass,
  [PassType.silver]: SilverPass,
  [PassType.bronze]: BronzePass
};

interface TranslationObject {
  translation: string;
  paramsCount: number;
}

export const PASS_AWARD_TRANSLATIONS: Omit<
  {
    [K in AwardType]: TranslationObject;
  },
  'other'
> = {
  [Award.Ticket]: { translation: '%0 %1 %2 ticket', paramsCount: 3 },
  [Award.Entry]: { translation: '%0 %1 %2 entry', paramsCount: 3 },
  [Award.Hotel]: { translation: '%0 nights at the %1 - %2 (%3)', paramsCount: 4 },
  [Award.Addon]: {
    translation:
      'Plus remaining value of the %0 credited as expenses, limited edition merchandise, live event liaison support and exclusive %1 activities',
    paramsCount: 2
  }
};

export const EVENT_TYPE_TRANSLATIONS: {
  [K in EventType]: string;
} = {
  [Event.Series]: 'Series Dates',
  [Event.Festival]: 'Festival Dates',
  [Event.Recurring]: 'Every'
};

export const DAY_OF_WEEK_TRANSLATIONS = [
  TXTINT_Monday,
  TXTINT_Tuesday,
  TXTINT_Wednesday,
  TXTINT_Thursday,
  TXTINT_Friday,
  TXTINT_Saturday,
  TXTINT_Sunday
];
